// extracted by mini-css-extract-plugin
module.exports =  {"tableBlock":"tableBlock__Guqrk","tabs":"tabs__T3fc-","resultTable":"resultTable__eLEM5","backToPCLink":"backToPCLink__FAia3"};